import ai from "./client-hints-parser.js";
import oi from "./user-agent-parser.js";
import { Browsers as gi, OperatingSystems as Y } from "./device-constants.js";
class ui {
  constructor() {
    const t = navigator.userAgentData ? ai : oi;
    (this.Sg = new t()),
      (this.userAgent = navigator.userAgent),
      (this.browser = this.Sg.tf()),
      (this.version = this.Sg.ef()),
      (this.OS = null),
      this.Oa().then((t) => (this.OS = t));
    const i = navigator;
    (this.language = (
      i.userLanguage ||
      i.language ||
      i.browserLanguage ||
      i.systemLanguage ||
      ""
    ).toLowerCase()),
      (this.Qo = ui.vg(this.userAgent));
  }
  OE() {
    return this.browser === gi.Bg;
  }
  Ga() {
    return this.OS || null;
  }
  Oa() {
    return this.OS
      ? Promise.resolve(this.OS)
      : this.Sg.Oa(ui.Og).then((t) => ((this.OS = t), t));
  }
  static vg(t) {
    t = t.toLowerCase();
    const i = [
      "googlebot",
      "bingbot",
      "slurp",
      "duckduckbot",
      "baiduspider",
      "yandex",
      "facebookexternalhit",
      "sogou",
      "ia_archiver",
      "https://github.com/prerender/prerender",
      "aolbuild",
      "bingpreview",
      "msnbot",
      "adsbot",
      "mediapartners-google",
      "teoma",
    ];
    for (let n = 0; n < i.length; n++) if (-1 !== t.indexOf(i[n])) return !0;
    return !1;
  }
}
ui.Og = [
  { string: navigator.platform, if: "Win", identity: Y.Pg },
  { string: navigator.platform, if: "Mac", identity: Y.kg },
  { string: navigator.platform, if: "BlackBerry", identity: "BlackBerry" },
  { string: navigator.platform, if: "FreeBSD", identity: "FreeBSD" },
  { string: navigator.platform, if: "OpenBSD", identity: "OpenBSD" },
  { string: navigator.platform, if: "Nintendo", identity: "Nintendo" },
  { string: navigator.platform, if: "SunOS", identity: "SunOS" },
  { string: navigator.platform, if: "PlayStation", identity: "PlayStation" },
  { string: navigator.platform, if: "X11", identity: "X11" },
  {
    string: navigator.userAgent,
    if: ["iPhone", "iPad", "iPod"],
    identity: Y.io,
  },
  { string: navigator.platform, if: "Pike v", identity: Y.io },
  { string: navigator.userAgent, if: ["Web0S"], identity: "WebOS" },
  {
    string: navigator.platform,
    if: ["Linux armv7l", "Android"],
    identity: Y.xg,
  },
  { string: navigator.userAgent, if: ["Android"], identity: Y.xg },
  { string: navigator.platform, if: "Linux", identity: "Linux" },
];
const X = new ui();
export { X as default, ui as BrowserDetector };
